
  import { Component, Vue ,Inject,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    @Inject() information:any
    get value(){
      return this.information
    }
    
    @Inject() editinfo:any
    get editmsg(){
      return this.information.find(v=>{
        return v.key == this.modekey
      })
    }
  }
